import React from 'react'
import Header from '../Layout/SignEnterprice/Header'
import Footer from '../Layout/SignEnterprice/Footer'
import Main from '../Layout/SignEnterprice/Main'

function SignEnterprice() {

    return (

        <>
        
            <Header/>

            <Main/>

            <Footer/>

        </>

    )

}

export default SignEnterprice